import { ApplicationId } from 'interfaces';

import {
  CompareSet,
  CompareSetId,
  CreateCompareSetPayload,
  UpdateCompareSetPayload,
} from 'interfaces/compare-set';

import { api } from './api';

/**
 * Fetches all compare sets belonging to the specified application.
 * @param applicationId the application ID.
 */
export function getCompareSets(applicationId: ApplicationId) {
  return api.get<CompareSet[]>(`/applications/${applicationId}/compare-sets`);
}

/**
 * Creates a new compare set for the specified application.
 * @param applicationId The application ID.
 * @param payload The request payload used to create the compare set.
 */
export function createCompareSet(applicationId: ApplicationId, payload: CreateCompareSetPayload) {
  return api.post<CompareSet>(`/applications/${applicationId}/compare-sets`, payload);
}

/**
 * Deletes an existing compare set belonging to the specified application.
 * @param applicationId The application ID.
 * @param compareSetId The compare set ID.
 */
export function deleteCompareSet(applicationId: ApplicationId, compareSetId: CompareSetId) {
  return api.delete(`/applications/${applicationId}/compare-sets/${compareSetId}`);
}

/**
 * Fetches a single compare set belonging to the specified application.
 * @param applicationId The application ID.
 * @param compareSetId The compare set ID.
 */
export function getCompareSet(applicationId: ApplicationId, compareSetId: CompareSetId) {
  return api.get<CompareSet>(`/applications/${applicationId}/compare-sets/${compareSetId}`);
}

/**
 * Updates an existing compare set belonging to the specified application.
 * @param applicationId The application ID.
 * @param compareSetId the compare set ID.
 * @param payload The request payload used to update the compare set.
 */
export function updateCompareSet(
  applicationId: ApplicationId,
  compareSetId: CompareSetId,
  payload: UpdateCompareSetPayload
) {
  return api.put<CompareSet>(
    `/applications/${applicationId}/compare-sets/${compareSetId}`,
    payload
  );
}
